import React from 'react'
import { RetentionResourceType, RetentionRuleType } from '../../../models/RetentionPolicy'

export const RetentionPolicyResourceType: React.FC<{ type: RetentionResourceType }> = ({ type }) => {
  if (type === RetentionResourceType.SESSION) {
    return <div>Meeting</div>
  }
  return <div>{type}</div>
}
